import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link as RouterLink } from 'react-router-dom';
import type { PageBreadcrumbItem } from '../../utils/pageBreadcrumbs';

export type { PageBreadcrumbItem };

interface PageBreadcrumbsProps {
  items: PageBreadcrumbItem[];
}

const crumbSx = {
  fontSize: '0.8125rem',
  lineHeight: 1.25,
  display: 'inline-flex',
  alignItems: 'center',
} as const;

const PageBreadcrumbs: React.FC<PageBreadcrumbsProps> = ({ items }) => {
  if (!items.length) return null;

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={
        <NavigateNextIcon
          sx={{ fontSize: '0.9rem', color: 'text.secondary', display: 'block' }}
        />
      }
      sx={{
        mb: 0,
        '& .MuiBreadcrumbs-ol': {
          flexWrap: 'wrap',
          rowGap: 0.25,
          alignItems: 'center',
        },
        '& .MuiBreadcrumbs-li': {
          display: 'inline-flex',
          alignItems: 'center',
        },
        '& .MuiBreadcrumbs-separator': {
          mx: 0.25,
          display: 'inline-flex',
          alignItems: 'center',
        },
      }}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        if (isLast || !item.to) {
          return (
            <Typography
              key={`${item.label}-${index}`}
              component="span"
              color="text.primary"
              sx={{ ...crumbSx, fontWeight: 600 }}
            >
              {item.label}
            </Typography>
          );
        }
        return (
          <Link
            key={`${item.to}-${index}`}
            component={RouterLink}
            to={item.to}
            underline="hover"
            sx={{
              ...crumbSx,
              color: '#1976d2',
              fontWeight: 500,
            }}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default PageBreadcrumbs;
